let str_slug = require('./global').str_slug;

  
  var defaults_opts = {
    'locale' : 'fr'
  }

// var fs = require('fs');
class mobileGenerator {
    constructor(opts) {
      this.options = Object.assign(defaults_opts, opts);
    }
    initialize() {
        // console.log('require', require('../../../../storage/app/jsonMenu/'+ this.options.locale +'_json_menu.json'))
        this.options.datas = require('../../../../public/app/jsonMenu/'+ this.options.locale +'_json_menu.json')
        // on gère ca en async , pour ne pas etre des brutes sur l'affichage ! Je peux gérer tous les niveaux comme ca !
        this.firstLevel().then((markup) => {
          let navbarMenu;
          // console.log('this', this)
          navbarMenu = $('.header-mobile-container .navigation-mobile-container').append(markup);
          this.secondLevel().then((genHtml) => {
            // console.log('genHtml', genHtml)
            // let navbarMenuItem = $('#navbarNav .nav-item').append(genHtml);
            $('.navigation-mobile-container .nav-mobile-item').each((index, el) => {
              $(el).append(genHtml[index])
            })
            this.lastLevel().then((arrHtml) => {
            //   console.log('arrHtml', arrHtml)
              $('.navigation-mobile-container .nav-mobile-item ').each((index, el) => {
                $(el).append(arrHtml[index])
              })
              this.eventsMobileMenu()
            })
          })
        });
        return this;
        // console.log('datas', this.options.datas)
    }
    async firstLevel() {  
        // console.log('firstLevel mobile')
        let FirstLevelMarkup = '';
        for (let mere_id in this.options.datas) {
                let Mere_object_id = this.options.datas[mere_id];

                
                  FirstLevelMarkup += '<li class="nav-mobile-item">';
                  FirstLevelMarkup +=   '<a class="nav-mobile-link" data-to=".first-level.'+str_slug(Mere_object_id.libelle)+'"  href="'+ Mere_object_id.url +'">' 
                        // {{$categorie['libelle'] }}
                  FirstLevelMarkup +=       Mere_object_id.libelle ;
                  FirstLevelMarkup +=   '</a>';
                  FirstLevelMarkup +=   '</li>';
                
        }
        return FirstLevelMarkup
    }
    async secondLevel() {
        // console.log('secondLevel mobile')
      let SecondLevelMarkupArr = new Array();
      for (let mere_id in this.options.datas) {
        // console.log('mere_id', mere_id)
        let Mere_object_id = this.options.datas[mere_id];
         if(parseInt(mere_id) === Mere_object_id.id) {
            let SecondLevelMarkup = '';

            
            
              SecondLevelMarkup += '<div class="mobile-dropdown first-level '+ str_slug(Mere_object_id.libelle) +'" aria-labelledby="">';
              SecondLevelMarkup +=    '<ul class="p-0 mb-4">';
              SecondLevelMarkup +=      '<a href="" data-to=".navigation-mobile" data-root=".first-level.'+ str_slug(Mere_object_id.libelle) +'" class="dropdown-title active-link"><span class="back-icon"><i class="material-icons">arrow_forward</i></span>'+ Mere_object_id.libelle +'</a>';
              for (let filles_id in this.options.datas[mere_id].filles) {
                let Filles_object_id = this.options.datas[mere_id].filles[filles_id];
                // Le Object Keys comme son nom l'indique ne retourne que les clés en array. et on count la dessus !
                // console.log('length', Object.keys(Filles_object_id).length)
                if(Object.keys(Filles_object_id).length > 0) {
                  
                  
                  SecondLevelMarkup +=  '<li><a class="nav-mobile-link" data-root=".first-level.'+ str_slug(Mere_object_id.libelle) +'" data-to=".last-level.'+ str_slug(Filles_object_id.libelle) +'" href="'+ Filles_object_id.url +'">'+ Filles_object_id.libelle +'</a></li>';
                  
                }
              }
              SecondLevelMarkup +=    '</ul>';
              SecondLevelMarkup +=  '</div>';

            
            SecondLevelMarkupArr.push(SecondLevelMarkup);
            
         }   
      }
      return SecondLevelMarkupArr
    }
    async lastLevel() {
        // console.log('lastLevel mobile')
      let LastLevelMarkupArr = new Array();
      // console.log('this.options.datas', this.options.datas);
      
      Object.keys(this.options.datas).forEach((key) => {
        // console.log('this.options.datas' +key)
        // console.log('obj by key ', this.options.datas[key])
        let Mere_object_id = this.options.datas[key];
        let LastLevelMarkup = '';
        
        for (let filles_id in Mere_object_id.filles) {
            let Filles_object_id = Mere_object_id.filles[filles_id];
            // console.log('Filles_object_id', Filles_object_id)
            
            if(parseInt(Filles_object_id.mere_id) === Mere_object_id.id) {
                    
                    LastLevelMarkup +='<div class="mobile-dropdown last-level '+ str_slug(Filles_object_id.libelle) +'" aria-labelledby="">'
                    LastLevelMarkup +=  '<ul class="p-0 mb-4">';
                    LastLevelMarkup +=      '<a href="" data-to=".first-level.'+ str_slug(Mere_object_id.libelle) +'" data-root=".last-level.'+ str_slug(Filles_object_id.libelle) +'" class="dropdown-title active-link"><span class="back-icon"><i class="material-icons">arrow_forward</i></span>'+ Filles_object_id.libelle +'</a>';
            
                    for (let fifille_id in Filles_object_id.filles) {
                        let Fifilles_object_id = Mere_object_id.filles[filles_id].filles[fifille_id];
                  
                  
                        LastLevelMarkup +=    '<li class=""><a class="mobile-dropdown-item" href="'+ Fifilles_object_id.url +'">'+ Fifilles_object_id.libelle +'</a></li>';
                        
    
                      
                
                
                
                    }
                    LastLevelMarkup += '</ul>';
                    LastLevelMarkup +='</div>';

              
            }

            
          
          
          
            
              
            
            
            
            
        }
        
        LastLevelMarkupArr.push(LastLevelMarkup); 
        
        

      })
      return LastLevelMarkupArr;
  }
  eventsMobileMenu() {
    // console.log('eventsMobileMenu mobile')
     // OPEN THE NAVIGATION
    var tlNavigation = new TimelineMax({paused:true});
    tlNavigation.set(".header-mobile-opened", {display: "none", left:"-100%", ease: Power3.easeOut})
    tlNavigation.fromTo(".header-mobile-opened", 0.5, {display: "none", left:"-100%", ease: Power3.easeOut}, {display: "block", left:0, ease: Power3.easeOut}, "0.1")
                .staggerFrom(".top-button", 0.2, {autoAlpha:0, y:-100, ease: Power3.easeOut}, "0.1")
                .from(".search-form-container", 0.5, {autoAlpha:0, x:100, ease: Power3.easeOut}, "+=0.1")
                .from(".slidable-content", 0.5, {autoAlpha:0, x:100, ease: Power3.easeOut}, "+=0.1");

    $('.hamb-menu-js').on('click', function(){
        $('body').addClass('body-lock');
        $('body').addClass('menu-mobile-opened');
        tlNavigation.timeScale(3).play();
    });

    //CLOSE THE NAVIGATION

    $('.close-mobile-nav-js').on('click', function(){
        $('body').removeClass('body-lock');
        setTimeout(() => {
          $('body').removeClass('menu-mobile-opened');
        }, 700)
        $('.custom-dropdown-country').slideUp();
        tlNavigation.timeScale(3).reverse();
    });

    $('.js-open-searchbox').on('click', function(e) {
      e.preventDefault();
      $('body').addClass('menu-mobile-opened');
      tlNavigation.timeScale(3).play();
      setTimeout(() => {
        $('.header-mobile-opened input[name="search-text"]').focus();
      }, 1000)
      
    })

    var tlNavigationDropdown = new TimelineMax({paused:true});
    var tlNavigationDropdownHide = new TimelineMax({paused:true});
    var ulContainer = $('.navigation-mobile-container');
  
    $('.nav-mobile-link').on('click', function(e){
      e.preventDefault();
      var lastElementClicked = $(this);
      var liContainer = $(lastElementClicked).parent();
      // var dropdown = $(liContainer).next('.mobile-dropdown');
      var dropdown = $(lastElementClicked).attr('data-to');
      var dataRoot = $(lastElementClicked).attr('data-root');
      var catLink = dropdown.split('.');
      // console.log('catLink nav-mobile-link', catLink)
      var otherLinkedDropdown;
      // var dropdownBackLink = $(lastElementClicked).find('.mobile-dropdown ul').find('.dropdown-title');
      var dropdownBackLink = $(lastElementClicked).next('.mobile-dropdown').find('ul').children().first()
      var alldropdown_not_this = liContainer.find('.mobile-dropdown').not(dropdown); 
     
    //   $(dropdown).hasClass('first-level') ? otherLinkedDropdown =  : 
     
      tlNavigationDropdown.fromTo(ulContainer, 0.3, {x: "0%", ease: Circ.easeInOut}, {x: "-100%", ease: Circ.easeInOut}, "+=0.1");

      if(catLink.indexOf('last-level') > -1) {
        // alert(true);
        tlNavigationDropdown.fromTo(dataRoot, 0.3, {position: "absolute",  top:0, left:0, width: "100%", y:0, display: "block", x: "0%", ease: Circ.easeInOut}, {position: "absolute", top:0, left:0, width: "100%", display: "none", x: "-100%", y:0, ease: Circ.easeInOut}, "+=0.1");
      }
      
      // else {
        tlNavigationDropdown.fromTo(dropdown, 0.3, {position: "absolute", top:0, left:0, width: "100%", y:0, display: "none", x: "200%", ease: Circ.easeInOut}, {position: "absolute", top:0, left:0, width: "100%", display: "block", x: "100%", y:0, ease: Circ.easeInOut}, "+=0.1");
      // }
      tlNavigationDropdown.timeScale(3).play();
    });
  
    $('.dropdown-title').on('click', function(e){
      e.preventDefault();
      var dropdownToHide = $(this).attr('data-to');
      var dataRoot = $(this).attr('data-root');
      var catLink = dropdownToHide.split('.');
      // console.log('catLink dropdown-title', catLink)
  
      // tlNavigationDropdownHide.fromTo(dropdownToHide, 0.3, {position: "absolute", top:0,opacity: 1, left:0, width: "100%", display: "block", x: "100%", ease: Circ.easeInOut}, {position: "absolute", top:0, left:0, opacity: 0,width: "100%", display: "none", x: "200%", ease: Circ.easeInOut}, "+=0.1");
      
      if(catLink.indexOf('first-level') > -1) {
        // alert(true);
        // correspond au dernier niveau
        tlNavigationDropdownHide.fromTo(dataRoot, 0.3, {position: "absolute", top:0, left:0, width: "100%", display: "block", x: "100%", ease: Circ.easeInOut}, {position: "absolute", top:0, left:0, width: "100%", display: "none", x: "-100%", ease: Circ.easeInOut}, "+=0.1");

        tlNavigationDropdownHide.fromTo('.first-level.'+catLink[catLink.length - 1], 0.3, {position: "absolute",  top:0, left:0, width: "100%", y:0, display: "none", x: "200%", ease: Circ.easeInOut}, {position: "absolute", top:0, left:0, width: "100%", display: "block", x: "100%", y:0, ease: Circ.easeInOut});
      }
      else {
        // le cas du premier niveau
        tlNavigationDropdownHide.fromTo(dataRoot, 0.3, {position: "absolute", top:0,left:0, width: "100%", display: "block", x: "100%", ease: Circ.easeInOut}, {position: "absolute", top:0, left:0, width: "100%", display: "none", x: "-100%", ease: Circ.easeInOut}, "+=0.1");
        tlNavigationDropdownHide.fromTo(ulContainer, 0.3, {x: "-100%", ease: Circ.easeInOut}, {x: "0%", ease: Circ.easeInOut}, "+=0.1");

      }

      // tlNavigationDropdownHide.fromTo($(dropdownToHide).parent().parent().parent(), 0.3, {x: "-100%", ease: Circ.easeInOut}, {x: "0%", ease: Circ.easeInOut}, "+=0.1");
      // tlNavigationDropdownHide.fromTo(ulContainer, 0.3, {x: "-100%", ease: Circ.easeInOut}, {x: "0%", ease: Circ.easeInOut}, "+=0.1");
  
      tlNavigationDropdownHide.timeScale(3).play();
    });
  }
}

export default mobileGenerator